import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EpErrorHandlerService {
  private errors: string[] = [];
  private errorSubject: ReplaySubject<string[]> = new ReplaySubject();

  constructor() {
    this.errorSubject.next(this.errors);
  }

  clearAll(): void {
    this.errors = [];
    this.errorSubject.next(this.errors);
  }

  clear = (): void => {
    this.errors.shift();
    this.errorSubject.next(this.errors);
  };

  get(): ReplaySubject<string[]> {
    return this.errorSubject;
  }

  push(err: string): void {
    if (this.errors.includes(err)) {
      return;
    }
    this.errors.push(err);
    this.errorSubject.next(this.errors);
    setTimeout(() => this.clear(), 9900);
  }
}
